<template>
  <span
    class="font-weight-bold text-center text-no-wrap rounded-pill"
    :key="status?.value"
    :class="{
      'text-body-2': $vuetify.breakpoint.smAndUp,
      'text-caption': $vuetify.breakpoint.xsOnly,
      'd-flex align-center': icon,
      'mt-0': noTopMargin,
      'mt-1 mt-sm-2': !noTopMargin,
    }"
    style="padding: 3px 12px"
    :style="{
      'background-color': `${status?.color ?? color ?? '#FFFFFF'}33`,
      color: `${status?.color ?? color ?? '#FFFFFF'}`,
    }"
  >
    <!-- Icon, if provided -->
    <v-icon
      v-if="icon"
      class="mr-2"
      :small="true"
      :color="status?.color ?? color ?? $vuetify.theme.currentTheme.primary"
    >
      {{ icon }}
    </v-icon>

    {{ status?.text }}
  </span>
</template>

<script>
// Libraries

// Components

export default {
  name: "StatusChip",
  data() {
    return {};
  },
  props: {
    icon: {
      default: undefined,
      type: [String, Object],
      required: false,
    },
    status: {
      default: undefined,
      type: Object,
      required: true,
    },
    size: {
      default: "",
      type: String,
      required: false,
    },
    iconSize: {
      default: "",
      type: String,
      required: false,
    },
    action: {
      default: () => {},
      type: Function,
      required: false,
    },
    to: {
      default: () => undefined,
      type: Object,
      required: false,
    },
    fontWeight: {
      default: "bold",
      type: String,
      required: false,
    },
    color: {
      default: "",
      type: String,
      required: false,
    },
    textColor: {
      default: "review",
      type: String,
      required: false,
    },
    textTransform: {
      default: "",
      type: [String, Boolean],
      required: false,
    },
    textStyle: {
      default: "",
      type: [String, Boolean],
      required: false,
    },
    textType: {
      default: "caption",
      type: String,
      required: false,
    },
    rounded: {
      default: "",
      type: String,
      required: false,
    },
    minHeight: {
      default: undefined,
      type: [String, Number, Object],
      required: false,
    },
    height: {
      default: undefined,
      type: [String, Number, Object],
      required: false,
    },
    maxHeight: {
      default: undefined,
      type: [String, Number, Object],
      required: false,
    },
    dense: {
      default: false,
      type: Boolean,
      required: false,
    },
    /** When true, skips default mt-1 / mt-sm-2 (parent `class="mt-0"` cannot override those utilities). */
    noTopMargin: {
      default: false,
      type: Boolean,
      required: false,
    },
    outlined: {
      default: false,
      type: Boolean,
      required: false,
    },
    loading: {
      default: false,
      type: Boolean,
      required: false,
    },
    text: {
      default: false,
      type: Boolean,
      required: false,
    },
    stacked: {
      default: false,
      type: Boolean,
      required: false,
    },
    depressed: {
      default: undefined,
      type: [Boolean, Object],
      required: false,
    },
    ripple: {
      default: undefined,
      type: [Boolean, Object],
      required: false,
    },
    block: {
      default: undefined,
      type: [Boolean, Object],
      required: false,
    },
    disabled: {
      default: undefined,
      type: [Boolean, Object],
      required: false,
    },
    minWidth: {
      default: undefined,
      type: [String, Number, Object],
      required: false,
    },
    width: {
      default: undefined,
      type: [String, Number, Object],
      required: false,
    },
    maxWidth: {
      default: undefined,
      type: [String, Number, Object],
      required: false,
    },
    extraClasses: {
      default: undefined,
      type: [String, Object],
      required: false,
    },
    // preset: {
    //   type: String,
    //   required: false,
    //   default: "",
    //   validator: function (value) {
    //     return ["", ...Object.keys(buttonPresets)].includes(value);
    //   },
    // },
  },
  methods: {
    /* API */
    // GET
    // POST
    /* */
    handleAction() {
      if (this.action) {
        this.action();
      }
    },
  },
  computed: {
    computedProps() {
      if (!this.preset) {
        return {};
      }
      return buttonPresets[this.preset] || {};
    },
    textTransformComputed() {
      return this.textTransform === true ||
        this.computedProps.textTransform === true
        ? "uppercase"
        : "none";
    },
    widthComputed() {
      return this.width ?? this.computedProps?.width ?? undefined;
    },
    minWidthComputed() {
      return this.minWidth ?? this.computedProps?.minWidth ?? undefined;
    },
  },
};
</script>

<style scoped>
/* .styled-button >>> .v-btn__content {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  gap: 8px;
}

.styled-button.flat::before {
  opacity: 0 !important;
}

.stacked >>> .v-btn__content {
  display: flex !important;
  flex-direction: column !important;
  gap: 4px;
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: normal !important;
}

.stacked.dense >>> .v-btn__content {
  display: flex !important;
  flex-direction: column !important;
  padding-top: 5px;
  padding-bottom: 5px;
  gap: 2px;
  font-size: 10px !important;
} */
</style>
